<template>
    <div>
        <a
            class="btn btn-sm is-ghost px-xl mr-md"
            @click="$modal.show(modalName)"
        >
            Felmeddelande
        </a>
        <adaptive-modal
            :name="modalName"
            :title="modalTitle"
            :hide-action-buttons="true"
        >
            {{ exportModel.error_message }}
        </adaptive-modal>
    </div>
</template>

<script>
    export default {
        props: {
            exportModel: {
                type: Object,
                required: true,
            },
        },
        computed: {
            modalName() {
                return `show-error-message-${this.exportModel.id}`;
            },
            modalTitle() {
                return `Felmeddelande för ${this.exportModel.name}`;
            },
        },
    };
</script>
